import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { Field, reduxForm, getFormValues } from 'redux-form';
import InputField from '../InputField';
import { required, numericality } from 'redux-form-validators';

const getYouTubeSrcFromId = (id) => `https://www.youtube.com/embed/${id}?showinfo=0`;

const youTubeGetID = (url) => {
  var ID = '';
  url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  if(url[2] !== undefined) {
      ID = url[2].split(/[^0-9a-z_\-]/i);
      ID = ID[0];
  }
  else {
      ID = url;
  }
  return ID;
}

class AddVideo extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      show: false,
    }
  }
  
  handleClose = () => {
    this.setState({
      show: false
    })
  }

  submit = (data) => {
    const {insertVideo} = this.props;

    if(insertVideo){
      insertVideo(getYouTubeSrcFromId(youTubeGetID(data.url)));
    }
    this.setState({show: false})
  }

  render() {
    const {show} = this.state;
    const {formatMessage} = this.context;
    const {handleSubmit} = this.props;
    return (
      <React.Fragment>
        <label><i onClick={() => this.setState({show: true})} className="fas fa-film"></i></label>
        <Modal
          isOpen = {show}
          style = {{
              overlay : {
                zIndex: 11111
              },
          }}
          onRequestClose={this.handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content"
        >
          <div className="create-dialog-modal-content__header">
            <div className="create-dialog-modal-content__title">{formatMessage('Insert YouTube video')}</div>
              <div
                  onClick={this.handleClose}
                  className="create-dialog-modal-content__close"
              ></div>
          </div>
          <div className="create-dialog-modal-content__body">
            <form className="create-dialog-form" onSubmit={handleSubmit(this.submit)}>
              <Field name="url" label="Link for YouTube video" component={InputField} validate={[required()]} />
              <div className="create-dialog-form__group flex flex-between">
                <button className="btn btn-primary" type="submit">Insert</button>
                <button className="btn btn-warning" onClick={this.handleClose} type="button">Cancel</button>
              </div>
            </form>
           
          </div>
        </Modal>
      </React.Fragment>
      
    );
  }
}

AddVideo = reduxForm({
  form: 'form_qbm_question_video',
  enableReinitialize: true,
})(AddVideo);

export default AddVideo;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/helpers/Fields/EditorMedia/AddVideo.jsx